import _ from "lodash";
import { store } from "src/redux/store";

export const IntegraionService = {
  getStoryBoardType: (type: string) => {
    if (type === "LANDING_PAGE") {
      return "Landing page";
    } else if (type === "INTERACTIVE_CONTENT") {
      return "Interactive experience";
    } else if (type === "RESOURCE_CENTER") {
      return "Resource center";
    } else if (type === "SPATIAL") {
      return "Spatial";
    }
    return "";
  },

  getIntegrationForCategory: (category: string) => {
    const state = store.getState();
    try {
      const items = _.get(
        state,
        "legacyRootReducer.settings.integrations.activated.items",
        [],
      ); //TODO: update the reducer once the app is fully migrated

      const integration = items
        .filter((item) => {
          return item != null;
        })
        .find((item) => {
          return _.get(item, "category.id") === category;
        });

      return integration;
    } catch (error) {
      console.error("Error in getIntegrationForCategory", error);
      return null;
    }
  },

  getIntegrations: () => {
    const integrations = [
      {
        type: "cleverstory",
        name: "Cleverstory",
        category: "CRM",
        adminOnly: true,
      },
      {
        type: "gmail",
        name: "Gmail",
        category: "EMAIL",
        adminOnly: false,
      },
      {
        type: "outlook",
        name: "Outlook",
        category: "EMAIL",
        adminOnly: false,
      },
      {
        type: "smtp",
        name: "SMTP",
        category: "EMAIL",
        adminOnly: false,
      },
      {
        type: "salesforce_v2",
        name: "Salesforce",
        category: "CRM",

        adminOnly: false,
        searchContacts: true,
      },
      {
        type: "freshsales",
        name: "Freshsales",
        category: "CRM",

        adminOnly: false,
        searchContacts: false,
      },
      {
        type: "hubspot",
        name: "Hubspot",
        category: "CRM",

        adminOnly: false,
        searchContacts: true,
      },
      {
        type: "pipedrive",
        name: "Pipedrive",
        category: "CRM",

        adminOnly: false,
        searchContacts: true,
      },
      {
        type: "klenty",
        name: "Klenty",
        category: "CADENCE",

        adminOnly: true,
      },
      {
        type: "outreach",
        name: "Outreach",
        category: "CADENCE",

        adminOnly: false,
      },
      {
        type: "intercom",
        name: "Intercom",
        category: "CHAT",

        adminOnly: true,
      },
      {
        type: "drift",
        name: "Drift",
        category: "CHAT",

        adminOnly: true,
      },
      {
        type: "google_analytics",
        name: "Google Analytics",
        category: "ANALYTICS",

        adminOnly: true,
      },
      {
        type: "google_analytics_4",
        name: "Google Analytics 4",
        category: "ANALYTICS",

        adminOnly: true,
      },
      {
        type: "google_tag_manager",
        name: "Google Tag Manager",
        category: "TAG_MANAGER",

        adminOnly: true,
      },
      {
        type: "six_sense",
        name: "Six Sense",
        category: "SIX_SENSE",

        adminOnly: true,
      },
      {
        type: "zoho_v2",
        name: "Zoho",
        category: "CRM",

        adminOnly: false,
        searchContacts: true,
      },
      {
        type: "ms_dynamics_v2",
        name: "MS Dynamics",
        category: "CRM",

        adminOnly: false,
        searchContacts: true,
      },
      {
        type: "salesloft",
        name: "Salesloft",
        category: "CADENCE",

        adminOnly: false,
        searchContacts: false,
      },
      {
        type: "marketo",
        name: "Marketo",
        category: "MARKETING_AUTOMATION",

        adminOnly: false,
      },
      {
        type: "slack",
        name: "Slack",
        category: "NOTIFICATIONS",

        adminOnly: false,
      },
      {
        type: "external_script",
        name: "External Script",
        category: "EXTERNAL_SCRIPT",

        adminOnly: true,
      },
      {
        type: "pardot",
        name: "Pardot",
        category: "CRM",

        adminOnly: false,
        searchContacts: false,
      },
      {
        type: "netsuite",
        name: "Netsuite",
        category: "CRM",

        adminOnly: false,
        searchContacts: true,
      },
      {
        type: "zoom",
        name: "Zoom",
        category: "VIDEO_COMMUNICATION",
        adminOnly: false,
      },
      {
        type: "fireflies",
        name: "Fireflies",
        category: "VIDEO_COMMUNICATION",
        adminOnly: true,
      },
    ];

    const integrationsV2 = [
      "zoho_v2",
      "ms_dynamics_v2",
      "salesforce_v2",
      "hubspot",
      "netsuite",
      "pardot",
    ];

    return {
      integrations: integrations,
      integrationsV2: integrationsV2,
    };
  },
};
